import customer from './customer'
import supplier from './supplier'
import project from './project'

export default {
  customer,
  supplier,
  project
}



// WEBPACK FOOTER //
// ./src/api/apis/self/information/index.js